import CompaniesPage from './CompaniesPage';

export default CompaniesPage;